import { TFunction } from 'i18next'

import { isRequestError } from './error-types'

// Simple primitive version, but better than nothing
export const getRequestErrorMessage = (
  error: unknown,
  t: TFunction,
  type: 'query' | 'mutation' = 'query',
) => {
  const unknownError = {
    title: t('request_errors.unknown_error'),
    message: t('request_errors.unknown_error_description'),
  }

  if (isRequestError(error)) {
    switch (error.type) {
      case 'client': {
        const details = error.errorDetails
        let keys = {}

        if (details !== null) {
          if ('keys' in details) {
            keys = { keys: details.keys.join(', ') }
          } else if ('line' in details) {
            keys = {
              line: details.line,
              content: details.content,
            }
          }
        }

        return {
          title:
            type === 'query'
              ? t('request_errors.query')
              : t('request_errors.mutation'),
          message: t(`client_errors.${error.code}`, keys),
        }
      }
      case 'network': {
        return {
          title: t('request_errors.network_error'),
          message: t('request_errors.network_error_description'),
        }
      }
      case 'server': {
        return {
          title: t('request_errors.server_error'),
          message: t('request_errors.server_error_description'),
        }
      }
      case 'decode_body':
      case 'decode_headers': {
        return {
          title: t('common.something_went_wrong'),
          message: t('request_errors.decode_response'),
        }
      }
      case 'parse_blob':
      case 'parse_json': {
        return {
          title: t('common.something_went_wrong'),
          message: t('request_errors.parse_response'),
        }
      }
      default: {
        return unknownError
      }
    }
  }

  return unknownError
}
